import { CircularProgress, CircularProgressProps } from '@mui/material';
import { TextMessage } from '../TextMessage/TextMessage';

export const LoadingIcon = ({ ...rest }: CircularProgressProps) => {
  return <TextMessage text={<CircularProgress color="inherit" {...rest} />} />;
};
